import React, { useEffect, useState } from "react";
import { getSSOlog } from "../../api/SSO";
import { useDispatch, useSelector } from 'react-redux'
import CustomTable from "../../hoc/CustomTable";

function SSOLog() {

    const [ssoLogs, setSSOlogs] = useState([])
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        getSSOlog().then((res) => {
            setLoading(false);
            if (res.data.status === 200) {
                console.log("res========>", res)
                setSSOlogs(res.data.data)
            }
        })
    }, [])

    const columns = [
        {
            title: 'created_at',
            dataIndex: 'created_at',
            type: 'custom',
            render: (data) => {
                return <td>{data.created_at}</td>
            }
        },
        {
            title: 'type',
            dataIndex: 'type',
            type: 'custom',
            render: (data) => {
                return <td>{data.type}</td>
            }
        },
        {
            title: 'error',
            dataIndex: 'error',
            type: 'custom',
            render: (data) => {
                return <td>{data.error}</td>
            }
        },


        // {
        //     title: 'updated_at',
        //     dataIndex: 'updated_at',
        //     type: 'custom',
        //     render: (data) => {
        //         return <td>{data.updated_at}</td>
        //     }
        // },

    ];
    return (
        <div className="container">
            <CustomTable
                columns={columns}
                tableData={ssoLogs}
                loading={loading}
                className="sso_table"
            />
        </div>
        // <div className="container">
        //     <table className="sso_table">
        //         <tr>
        //             <th style={{ "border": "1px solid black" }}>created_at</th>
        //             <th style={{ "border": "1px solid black" }}>type</th>
        //             <th style={{ "border": "1px solid black" }}>error</th>
        //         </tr>
        //         {ssoLogs?.map((item, i) => {
        //             return (
        //                 <tr>
        //                     <td style={{ "border": "1px solid black" }}>{item?.created_at}</td>
        //                     <td style={{ "border": "1px solid black" }}>{item?.type}</td>
        //                     <td style={{ "border": "1px solid black" }}>{item?.error}</td>
        //                 </tr>
        //             )

        //         })}
        //     </table>
        // </div>
    );
}

export default SSOLog;
